<template>
    <page-template page-id="SetCountry" ref="super">

        <document-title :title="$tb('pages.setCountry.documentTitle')"></document-title>

        <template v-slot:before v-if="isTitlebarActive">
            <titlebar :text="$tb('pages.setCountry.header', {0: $store.state.appName})"></titlebar>
        </template>

        <div class="ui column">

            <brand-header :text="$t('pages.setCountry.title')"
                          :has-extension="hasHeaderExtension"
                          :has-logo="hasBrandLogo">
            </brand-header>

            <p v-html="$t( 'pages.setCountry.subheader' )"></p>

            <messages id="Notifications" ref="postman"></messages>

            <template>
                <validated-field :show-errors-on="showErrors" :has-any-errors="$v.country.$invalid"
                                 :validation-rules="[{value: $v.country.required, msg: $t('common.validation.field.empty')}]">
                    <dropdown-select v-if="isMobile()" id="country" name="country" v-model="$v.country.$model"
                                     classes="ui fluid dropdown selection"
                                     :placeholder="$t('common.label.country')"
                                     :mandatory="true"
                                     :options="countryOptions"></dropdown-select>
                    <dropdown-mk2 v-else id="country" name="country" v-model="$v.country.$model"
                                  classes="ui fluid selection dropdown"
                                  :placeholder="$t('common.label.country')"
                                  :mandatory="true"
                                  :options="countryOptions"></dropdown-mk2>
                </validated-field>
                <mandatory-label></mandatory-label>
            </template>
            <template>
                <div class="field">
                    <button id="continue" type="submit" @click.prevent="onContinue" class="ui fluid primary button">
                        {{$t('common.button.continue')}}
                    </button>
                </div>
            </template>
            <div class="field" v-if="getConfig('setCountry_hasBackButton')">
                <button id="back" @click="goBack" class="ui fluid basic button">
                    {{$t('common.button.back')}}
                </button>
            </div>
        </div>
    </page-template>
</template>
<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import BrandHeader from '../components/BrandHeader.vue'
import DropdownMk2 from '../components/DropdownMk2.vue'
import DropdownSelect from '../components/DropdownSelect.vue'
import Messages from '../components/Messages.vue'
import MandatoryLabel from '../components/MandatoryLabel.vue'
import ValidatedField from '../components/ValidatedField.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    PageTemplate,
    Titlebar,
    BrandHeader,
    Messages,
    MandatoryLabel,
    ValidatedField,
    DropdownMk2,
    DropdownSelect
  },
  mixins: [mixin, brand],
  data: function () {
    return {
      country: '',
      showErrors: false
    }
  },
  props: {
    uid: {
      type: String,
      default: ''
    }
  },
  validations () {
    return {
      country: { required }
    }
  },
  methods: {
    onContinue: function (e) {
      //  remove previous errors
      this.$refs.postman.clear()
      this.showErrors = false

      if (!this.isFormValid()) return

      this.$refs.super.startLoading()

      const payload = this.$api.payloads.buildSetCountryPayload(this.country)
      this.$api.login.setCountry(this.uid, payload, this.onSuccess, this.onFail)
    },
    isFormValid: function () {
      if (!this.$v.$anyDirty || this.$v.$anyError || this.$v.$invalid) {
        const _this = this

        this.focusFirstErrorField(function () {
          _this.showErrors = true
        })

        return false
      }

      return true
    },
    onSuccess: function (response) {
      this.$store.commit('country', this.country)
      this.handleRoutingResponse(response)
    },
    onFail: function (response) {
      this.onAjaxError(response)
      this.$refs.super.stopLoading()
    },
    goBack: function () {
      window.history.length > 1 ? window.history.back() : this.$router.push('/')
    },
    checkHideErrors: function () {
      if (this.$v.$invalid) return

      this.showErrors = false
    }
  },
  computed: {
    countryOptions: function () {
      return this.$tCountries(false)
    }
  },
  mounted: function () {
    console.log(`Set country [uid=${JSON.stringify(this.uid)}]`)
  },
  watch: {
    $v: {
      handler () {
        this.checkHideErrors()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>
